module.exports = __webpack_public_path__ + "img/eye-mature-4-skin-fibers.c9fa4fef.jpg";